import BaseEllipsisText from '@/components/base/BaseEllipsisText';
import useMenu from '@/hooks/useMenu';
import { useIntl } from '@/i18n';
import { history } from '@/router/navigate';
import { isExternal } from '@/utils';
import { Breadcrumb } from 'antd';
import { useMatches } from 'react-router';

/** 头部面包屑：由权限树链路生成 */
export default function Breadcrumbs() {
  const { breadcrumbs, getTitle } = useMenu();
  const intl = useIntl();
  const handle = useMatches().at(-1)?.handle as
    | { breadcrumbTitle?: string }
    | undefined;
  const nodes: typeof breadcrumbs = handle?.breadcrumbTitle
    ? [
        ...breadcrumbs,
        {
          code: handle.breadcrumbTitle,
          kind: 'page',
          title: intl.formatMessage({ id: handle.breadcrumbTitle }),
        },
      ]
    : breadcrumbs;

  if (!breadcrumbs.length) return null;

  return (
    <Breadcrumb
      separator={
        <span
          className="admin-breadcrumb-chevron size-[5px] border-0 border-t border-r border-solid border-current rotate-45"
          aria-hidden
        />
      }
      items={nodes.map((node, index) => {
        const isLast = index === nodes.length - 1;
        const clickable = !isLast && !!node.path && !isExternal(node.path);
        return {
          title: (
            <span
              className="admin-breadcrumb-title"
              aria-current={isLast ? 'page' : undefined}
            >
              <BaseEllipsisText title={getTitle(node)} />
            </span>
          ),
          onClick: clickable ? () => history.push(node.path!) : undefined,
          className: clickable ? 'ant-breadcrumb-link' : undefined,
          style: clickable ? { cursor: 'pointer' } : undefined,
        };
      })}
    />
  );
}
